angular.module('env.i18n.serverLocalization', [])

    .service('serverLocalization', function ($q, $log, toastr, serverLocalizationCache, localizationRepository, EventingMixin, LocaleName) {
        var _this = this;
        _this = _.extend(_this, new EventingMixin(['changed']));

        /**
         * Cache of available languages
         * @type {Array}
         */
        var languagesList;

        /**
         * Default language
         * @type {string}
         */
        var defaultLanguage = "en-GB";

        /**
         * Current language
         * @type {string}
         */
        var currentLanguage;

        /**
         * Get list of server supported languages
         * @returns {!Promise} promise
         */
        _this.getLanguagesList = function () {
            var deferred = $q.defer();
            if (languagesList) {
                deferred.resolve(languagesList);
            } else {
                localizationRepository.getLanguages()
                    .then(function (resp) {
                        try {
                            languagesList = resp;
                            deferred.resolve(languagesList);
                        } catch (err) {
                            languagesList = null;
                            deferred.reject(err);
                        }
                    }, function (err) {
                        deferred.reject(err);
                    });
            }

            return deferred.promise;
        };

        /**
         * Set current language for server translations
         * @param {string} lang code of the language
         * @returns {!Promise} promise
         */
        _this.setCurrentLanguage = function (lang) {
            var deferred = $q.defer();

            _this.getLanguagesList().then(
                function (langList) {
                    // get the most suitable language code
                    var languageCode = (new LocaleName(lang)).getMostSuitableLanguage(langList) || defaultLanguage;

                    if (serverLocalizationCache.hasLanguage(languageCode)) {
                        currentLanguage = languageCode;
                        _this.events.raise('changed', {language: languageCode});
                        deferred.resolve(languageCode);
                    } else {
                        updateCache(languageCode).then(
                            function () {
                                currentLanguage = languageCode;
                                _this.events.raise('changed', {language: languageCode});
                                deferred.resolve(languageCode);
                            },
                            function (err) {
                                deferred.reject(err);
                            }
                        );
                    }
                },
                function (err) {
                    deferred.reject(err);
                }
            );

            return deferred.promise;
        };

        /**
         * Get current server localization language
         * @returns {string} current server localization language code
         */
        _this.getCurrentLanguage = function () {
            return currentLanguage;
        };

        /**
         * Update cache from server
         * @param {string} lang language
         * @param {Array} [keys] [Optional] keys to update. If not set - update all language
         */
        var updateCache = function (lang, keys) {
            return localizationRepository.getTranslations(lang, keys)
                .then(function (resp) {
                    _.forEach(resp, function (el) {
                        if (el && el.resourceCode && el.value) {
                            serverLocalizationCache.setValue(lang, el.resourceCode, el.value);
                        }
                    });
                });
        };

        /**
         * Get server translations for array of keys
         * @param {Array} keys keys for translation
         * @returns {{}} translations hash object
         */
        _this.translateMany = function (keys) {
            var result = {};
            _.forEach(keys, function (el) {
                result[el] = translateInternal(el);
            });
            return result;
        };

        /**
         * Get server translations for key
         * @param {string} key
         * @returns {string} translation
         */
        _this.translate = function (key) {
            var message;

            if (!key) {
                return null;
            }
            var translated = translateInternal(key);

            if (arguments.length > 1) { // if we have arguments for string format
                var insertions = _.flatten(Array.prototype.slice.call(arguments, 1));

                if (!translated) {
                    message = "Translation for key `" + key
                        + "` is empty for `" + currentLanguage
                        + "` locale. UI localization engine was unable to format empty string with given arguments: "
                        + insertions.join(', ');
                    $log.warn(message);
                    toastr.warning(message, "UI localization error");
                    return key;
                }

                try {
                    return _.string.sprintf(translated, insertions);
                } catch (error) {
                }
                message = "UI localization engine was unable to format translated string `" + translated
                    + "` (key: '" + key + "', locale: '" + currentLanguage + "') with given arguments: " + insertions.join(', ');
                $log.warn(message);
                toastr.warning(message, "UI localization error");
                return translated;
            }

            return translated;
        };

        function translateInternal(key) {
            var t = serverLocalizationCache.getValue(currentLanguage, key);
            if (!t) {
                return om.config.build.highlightUntranslatedStrings === true
                    ? "[MISSING_SRV]:" + key
                    : key;
            }
            return t;
        }

        return _this;
    })

    .service('serverLocalizationCache', function () {
        var _this = this;

        var cache = {};

        /**
         * Get cached translation for key and language
         * @param {string} lang language
         * @param {string} key translation key
         * @returns {string} cached translation
         */
        _this.getValue = function (lang, key) {
            if (lang in cache && key in cache[lang]) {
                return cache[lang][key];
            }
        };

        /**
         * Add new cached value
         * @param {string} lang language
         * @param {string} key key of the resource
         * @param {string} value translation
         */
        _this.setValue = function (lang, key, value) {
            if (!cache[lang]) {
                cache[lang] = {};
            }
            cache[lang][key] = value;
        };

        /**
         * Check if language already cached
         * @param {string} lang language
         * @returns {boolean} true if cached
         */
        _this.hasLanguage = function (lang) {
            return !!cache[lang];
        };

        return _this;
    })

;